import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";
const token = Auth.getToken();
/**
 * 
 * 
 * @param businessType  业务类型
 * "avatar": 头像上传
 * "tts": 语音生成"
 * "voiceChange":变声"
 * "cloneVoice":克隆声音
 * "person":人物声音
 */
export const uploadFileCommon=async(file: any,businessType:string,parentIds:any)=>{
    
    const formDatas = new FormData();
    formDatas.append('file',file.raw);
    formDatas.append('businessType',businessType);
    formDatas.append('parentId',parentIds);
    let str
    
    const option = {
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };
   await fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return  response.json()
            }
        })
        .then(data=> {
            console.log(data)
            str=data
            return str
        })
     return str
}